"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalFields = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const useSetFormData_1 = require("../../hooks/useSetFormData");
const lodash_1 = __importDefault(require("lodash"));
const FeesableDialog_1 = __importDefault(require("../FeesableDialog/FeesableDialog"));
const InfoPopup_1 = require("./InfoPopup");
const icons_material_1 = require("@mui/icons-material");
const shouldApply = (currentBreakdownStudent, rule) => {
    const getSortValueByGrade = (grade) => {
        if (!isNaN(Number(grade)))
            return 10 + parseInt(grade);
        if (grade === 'P')
            return 1;
        if (grade === 'K')
            return 2;
        if (grade === 'A')
            return 1;
        if (grade === 'B')
            return 2;
        if (grade === 'C')
            return 3;
        return 0;
    };
    const isInAgeRange = (range) => {
        if (range === '*')
            return true;
        if (Array.isArray(range))
            return range.map((rg) => isInAgeRange(rg)).some((res) => res);
        const parts = range.split('-');
        const compare = getSortValueByGrade(currentBreakdownStudent.grade);
        return parts.length === 1
            ? compare === getSortValueByGrade(parts[0])
            : compare >= getSortValueByGrade(parts[0]) &&
                compare <= getSortValueByGrade(parts[1]);
    };
    if (!isInAgeRange(rule.grades))
        return false;
    if (rule.variants &&
        !rule.variants.includes(currentBreakdownStudent.variant || ''))
        return false;
    if ((rule.params || {}).newStudentsOnly &&
        !currentBreakdownStudent.newStudent)
        return false;
    if (rule.sites &&
        !(rule.sites.includes('*') ||
            rule.sites.includes(currentBreakdownStudent.site)))
        return false;
    return true;
};
const prepareExtras = (currentBreakdownStudent, extrasRaw) => {
    const refined = { sections: [], subSections: [], matrix: [] };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sections = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subSections = {};
    refined.matrix = extrasRaw.matrix.filter((item) => {
        if (item.grades === 'none')
            return false;
        if (!shouldApply(currentBreakdownStudent, item))
            return false;
        if (!subSections[item.parent]) {
            const sub = extrasRaw.subSections.find((ss) => ss.id === item.parent);
            if (!sub)
                return false;
            subSections[item.parent] = sub;
            refined.subSections.push(sub);
            if (!sections[sub.parent]) {
                const sec = extrasRaw.sections.find((s) => s.id === sub.parent);
                if (!sec)
                    return false;
                sections[sub.parent] = sec;
                refined.sections.push(sec);
            }
        }
        return true;
    });
    return refined;
};
const StyledContentWrapper = (0, styles_1.styled)(material_1.DialogContent)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
}));
const StyledContentHeader = (0, styles_1.styled)(material_1.Unstable_Grid2)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.custom.primary}`,
    [theme.breakpoints.down('sm')]: {
        backgroundColor: theme.palette.background.default,
        zIndex: 1000,
        position: 'sticky',
        top: -16,
    },
}));
const StyledScrollingColumn = (0, styles_1.styled)(material_1.Unstable_Grid2)(() => ({
    flexGrow: 1,
    overflow: 'auto',
}));
const ExtrasRow = ({ field, selectedItems, setSelectedItems, }) => {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const buttons = [];
    const modifyItems = (id, instruction, value) => {
        switch (instruction) {
            case 'add': {
                const selected = selectedItems.find((item) => item.id === id);
                if (selected === undefined)
                    setSelectedItems([
                        ...selectedItems,
                        { id, count: field.min || 1, value },
                    ]);
                break;
            }
            case 'remove':
                setSelectedItems(selectedItems.filter((item) => item.id !== id));
                break;
            case 'increase':
                setSelectedItems(selectedItems.map((item) => {
                    if (item.id === id && (!field.max || item.count < field.max))
                        return Object.assign(Object.assign({}, item), { count: item.count + 1 });
                    return item;
                }));
                break;
            case 'decrease': {
                const modifiedItems = [];
                selectedItems.forEach((item) => {
                    const min = field.min || 1;
                    if (item.id !== id) {
                        modifiedItems.push(item);
                    }
                    else if (item.count > min) {
                        modifiedItems.push(Object.assign(Object.assign({}, item), { count: item.count - 1 }));
                    }
                });
                setSelectedItems(modifiedItems);
                break;
            }
            default:
                throw new Error(`Invalid instruction ${instruction}`);
        }
    };
    const selected = selectedItems.find((item) => item.id === field.id);
    if (field.type === 'addRemove') {
        buttons.push(selected === undefined
            ? { label: 'Add', instruction: 'add' }
            : { label: 'Remove', instruction: 'remove' });
    }
    else if (field.type === 'count') {
        if (!selected) {
            buttons.push({ label: 'Add', instruction: 'add' });
        }
        else {
            const isMax = field.max && selected.count >= field.max;
            buttons.push({
                label: '-',
                instruction: 'decrease',
                disabled: selected.count === 0,
            });
            buttons.push({ label: '+', instruction: 'increase', disabled: !!isMax });
        }
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.ListItemButton, { sx: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            px: 0,
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { sx: { fontWeight: 'normal', fontSize: 16 }, children: [field.label, field.info && (0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: field.id, infos: [field.info] })] }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { display: 'flex' }, children: buttons.map((button) => ((0, jsx_runtime_1.jsx)(material_1.Button, { size: "small", sx: { marginLeft: 1 }, disabled: button.disabled, variant: button.label === 'Remove' ? 'contained' : 'outlined', onClick: () => modifyItems(field.id, button.instruction), children: button.label }, button.label))) })] }));
};
const NavigationIconButton = ({ position, direction, onClick, }) => ((0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: onClick, sx: { position, [direction]: 16, top: 12 }, children: direction === 'left' ? (0, jsx_runtime_1.jsx)(icons_material_1.ArrowBack, {}) : (0, jsx_runtime_1.jsx)(icons_material_1.ArrowForward, {}) }));
const ActionButtons = ({ isFirstStudent = false, isLastStudent = false, onCancel, onSave, onPrevious, onNext, }) => {
    const theme = (0, styles_1.useTheme)();
    const isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
            flexGrow: 1,
            paddingLeft: 3,
            paddingRight: isLastStudent ? 0 : 3,
        }, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { size: "small", onClick: onCancel, children: "Cancel" }), !isFirstStudent && !isMobile && onPrevious && ((0, jsx_runtime_1.jsx)(material_1.Button, { size: "small", variant: "outlined", onClick: onPrevious, children: "Previous Student" })), isLastStudent ? ((0, jsx_runtime_1.jsx)(material_1.Button, { size: "small", variant: "contained", onClick: onSave, children: "Save & View Results" })) : (!isMobile &&
                onNext && ((0, jsx_runtime_1.jsx)(material_1.Button, { size: "small", variant: "outlined", onClick: onNext, children: "Next Student" })))] }));
};
const AdditionalFields = ({ currentBreakdownStudent, extrasOpen, setExtrasOpen, config, formData, handleNext, handlePrevious, isLastStudent, isFirstStudent, }) => {
    const [selectedItems, setSelectedItems] = (0, react_1.useState)([]);
    const [expandedSection, setExpandedSection] = (0, react_1.useState)('');
    const setFormData = (0, useSetFormData_1.useSetFormData)();
    const theme = (0, styles_1.useTheme)();
    (0, react_1.useEffect)(() => {
        var _a;
        setSelectedItems([]);
        const student = formData.students.find((student) => student.id === currentBreakdownStudent.id);
        const extras = (_a = student === null || student === void 0 ? void 0 : student.extras) === null || _a === void 0 ? void 0 : _a.find((extra) => extra.year === currentBreakdownStudent.startYear);
        if (extras)
            setSelectedItems(extras.selected);
    }, [formData, currentBreakdownStudent]);
    const extras = config.extras
        ? prepareExtras(currentBreakdownStudent, config.extras)
        : undefined;
    const toggleSection = (sectionId) => {
        if (expandedSection === sectionId) {
            setExpandedSection('');
        }
        else {
            setExpandedSection(sectionId);
        }
    };
    if (!extras)
        return null;
    const getSelectedItemText = (selectedItem) => {
        const item = extras.matrix.find((i) => i.id === selectedItem.id);
        if (!item)
            return 'Invalid Item Selected';
        const subSection = extras.subSections.find((i) => i.id === item.parent);
        let text = `${subSection === null || subSection === void 0 ? void 0 : subSection.label} - ${item.label}`;
        if (item.type === 'count' && selectedItem.count)
            text = `${text} (${selectedItem.count})`;
        return text;
    };
    // Save extra activities against the child. This resubmits for calculation
    // TODO: have had to do lots of cloning here, we should sort this out
    const handleSaveExtras = (selectedItems, isSaveExtras = false) => {
        const students = formData.students.map((student) => {
            if (student.id !== currentBreakdownStudent.id)
                return lodash_1.default.cloneDeep(student);
            const yearExtras = {
                year: currentBreakdownStudent.startYear,
                selected: [...selectedItems],
            };
            const extras = student.extras
                ? student.extras.filter((e) => e.year !== yearExtras.year)
                : [];
            extras.push(yearExtras);
            return Object.assign(Object.assign({}, student), { extras: extras.map((e) => lodash_1.default.cloneDeep(e)) });
        });
        if (isSaveExtras) {
            setFormData(Object.assign(Object.assign({}, formData), { students }), true);
            setExtrasOpen(false);
        }
        else {
            setFormData(Object.assign(Object.assign({}, formData), { students }), true, true);
        }
    };
    const getStudentsWithoutExtras = () => {
        if (!(formData === null || formData === void 0 ? void 0 : formData.students))
            return 0;
        return formData.students.filter((student) => {
            return (!student.extras ||
                student.extras.every((extra) => { var _a; return !((_a = extra.selected) === null || _a === void 0 ? void 0 : _a.length); }));
        }).length;
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (expandedSection === '') {
            setExpandedSection((_a = extras.subSections[0]) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [extras]);
    if (!extrasOpen)
        return null;
    return ((0, jsx_runtime_1.jsx)(FeesableDialog_1.default, { open: true, size: "lg", children: (0, jsx_runtime_1.jsxs)(StyledContentWrapper, { children: [(0, jsx_runtime_1.jsx)(StyledContentHeader, { container: true, spacing: 2, children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h4", sx: { fontWeight: 'bold' }, children: [currentBreakdownStudent.name, " - Grade", ' ', currentBreakdownStudent.grade] }) }), (0, jsx_runtime_1.jsxs)(material_1.Unstable_Grid2, { container: true, spacing: 2, children: [(0, jsx_runtime_1.jsx)(StyledScrollingColumn, { xs: 12, md: 6, mt: 2, sx: {
                                [theme.breakpoints.up('md')]: {
                                    marginBottom: 10,
                                },
                            }, children: extras.sections.map((section, i) => ((0, jsx_runtime_1.jsxs)(material_1.Box, { mt: i ? 4 : 0, children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { sx: { fontWeight: 'bold', fontSize: 26 }, children: [section.label, section.info && ((0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: section.id, infos: [section.info] }))] }), extras.subSections
                                        .filter((ss) => ss.parent === section.id)
                                        .map((subSection) => ((0, jsx_runtime_1.jsxs)(material_1.Accordion, { expanded: subSection.id === expandedSection, sx: { boxShadow: 'none' }, onChange: () => toggleSection(subSection.id), children: [(0, jsx_runtime_1.jsx)(material_1.AccordionSummary, { sx: { mb: 0, mx: 0 }, expandIcon: (0, jsx_runtime_1.jsx)(ExpandMore_1.default, {}), id: `${section.id}_${subSection.id}`, children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { sx: { fontWeight: 'medium', fontSize: 20 }, children: [subSection.label, subSection.info && ((0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: subSection.id, infos: [subSection.info] }))] }) }), (0, jsx_runtime_1.jsx)(material_1.AccordionDetails, { children: (0, jsx_runtime_1.jsx)(material_1.Stack, { children: extras.matrix
                                                        .filter((f) => f.parent === subSection.id)
                                                        .map((field) => ((0, jsx_runtime_1.jsx)(ExtrasRow, { field: field, selectedItems: selectedItems, setSelectedItems: setSelectedItems }, field.id))) }) })] }, `${section.id}_${subSection.id}`)))] }, section.id))) }), (0, jsx_runtime_1.jsxs)(material_1.Unstable_Grid2, { xs: 12, md: 6, mt: 2, mb: 10, children: [(0, jsx_runtime_1.jsxs)(material_1.Card, { variant: "outlined", sx: { p: 4, bgcolor: 'custom.surfaceMedium' }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", children: "Selected" }), !selectedItems.length && ((0, jsx_runtime_1.jsx)(material_1.ListItemButton, { sx: { fontStyle: 'italic', color: 'custom.textMedium' }, children: "Select extra activities for this child from available items. Once added, they will show up here." }, 'first')), !!selectedItems.length && ((0, jsx_runtime_1.jsx)(material_1.Stack, { children: selectedItems.map((item) => ((0, jsx_runtime_1.jsx)(material_1.ListItemButton, { sx: { fontStyle: 'normal' }, children: getSelectedItemText(item) }, item.id))) }))] }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                        position: 'absolute',
                                        right: 24,
                                        bottom: 24,
                                        backgroundColor: 'background.paper',
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: 2,
                                        zIndex: 10,
                                        [theme.breakpoints.down('sm')]: {
                                            position: 'fixed',
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            width: '100%',
                                            padding: 2,
                                            justifyContent: 'center',
                                        },
                                    }, children: (0, material_1.useMediaQuery)(theme.breakpoints.down('sm')) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isFirstStudent && ((0, jsx_runtime_1.jsx)(NavigationIconButton, { position: "absolute", direction: "left", onClick: () => {
                                                    handleSaveExtras(selectedItems);
                                                    handlePrevious();
                                                } })), (0, jsx_runtime_1.jsx)(ActionButtons, { isFirstStudent: isFirstStudent, isLastStudent: isLastStudent, onCancel: () => setExtrasOpen(false), onSave: () => handleSaveExtras(selectedItems, true), onPrevious: () => {
                                                    handleSaveExtras(selectedItems);
                                                    handlePrevious();
                                                }, onNext: () => {
                                                    handleSaveExtras(selectedItems);
                                                    handleNext();
                                                }, studentsWithoutExtras: getStudentsWithoutExtras() }), !isLastStudent && ((0, jsx_runtime_1.jsx)(NavigationIconButton, { position: "absolute", direction: "right", onClick: () => {
                                                    handleSaveExtras(selectedItems);
                                                    handleNext();
                                                } }))] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ActionButtons, { isFirstStudent: isFirstStudent, isLastStudent: isLastStudent, onCancel: () => setExtrasOpen(false), onSave: () => handleSaveExtras(selectedItems, true), onPrevious: () => {
                                                handleSaveExtras(selectedItems);
                                                handlePrevious();
                                            }, onNext: () => {
                                                handleSaveExtras(selectedItems);
                                                handleNext();
                                            }, studentsWithoutExtras: getStudentsWithoutExtras() }) })) })] })] })] }) }));
};
exports.AdditionalFields = AdditionalFields;
